import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from '../context/AuthContext';
import { Button } from '../components/ui/button';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error | expired

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then((res) => {
        if (res.data?.message?.includes('già verificata')) {
          setStatus('already');
        } else {
          setStatus('success');
        }
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail || '';
        if (detail.toLowerCase().includes('scaduto')) {
          setStatus('expired');
        } else {
          setStatus('error');
        }
      });
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const content = {
    loading: {
      icon: '⏳',
      title: 'Verifica in corso...',
      text: 'Stiamo verificando il tuo indirizzo email.',
      cta: null,
    },
    success: {
      icon: '✅',
      title: 'Email verificata!',
      text: 'Il tuo indirizzo email è stato confermato con successo. Puoi ora accedere a tutte le funzionalità della piattaforma.',
      cta: <Link to="/login"><Button className="w-full">Vai al login</Button></Link>,
    },
    already: {
      icon: 'ℹ️',
      title: 'Email già verificata',
      text: 'Il tuo indirizzo email è già stato verificato in precedenza.',
      cta: <Link to="/"><Button variant="outline" className="w-full">Torna alla home</Button></Link>,
    },
    expired: {
      icon: '⏱️',
      title: 'Link scaduto',
      text: 'Il link di verifica è scaduto (validità 24 ore). Accedi al tuo account e richiedi un nuovo link.',
      cta: <Link to="/login"><Button className="w-full">Accedi e richiedi nuovo link</Button></Link>,
    },
    error: {
      icon: '❌',
      title: 'Link non valido',
      text: 'Il link di verifica non è valido o è già stato utilizzato.',
      cta: <Link to="/login"><Button className="w-full">Torna al login</Button></Link>,
    },
  };

  const c = content[status];

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-xl shadow-sm border border-stone-200 p-8">
          <div className="text-5xl mb-4">{c.icon}</div>
          <h2 className="text-xl font-semibold text-stone-900 mb-2">{c.title}</h2>
          <p className="text-stone-600 mb-6">{c.text}</p>
          {c.cta}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
